var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 7.38462,
    height: 7.38462,
    rx: 1,
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6172,
    y: 8,
    width: 7.38462,
    height: 7.38462,
    rx: 1,
    fill: "#707070"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16.6172,
    width: 7.38462,
    height: 7.38462,
    rx: 1,
    fill: "#707070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6172,
    y: 16.6172,
    width: 7.38462,
    height: 7.38462,
    rx: 1,
    fill: "#707070"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid1);
export default __webpack_public_path__ + "static/media/grid1.5017b59d255506336fdd0ed069bd47e3.svg";
export { ForwardRef as ReactComponent };